(function ($) {
    $(() => {
        $('.hamburger').on('click', function () {
            $('.mobile-menu-wrapper').toggleClass('show');
            $(this).toggleClass('is-active');
            $('.header').toggleClass('mobil-header');
            $('.searching').toggleClass('menu-opened');
        });

        $('.dropdown-toggle-arrow').on('click', function (e) {
            e.preventDefault();
            $(this).parent().siblings('.dropdown-menu').toggleClass('show');
            $(this).toggleClass('rotate');
        });
    });
})(jQuery);
